<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div style="position: relative; padding-bottom: 0px;" :style="appStyle">
    <!-- 吸顶导航栏 -->
    <div 
      ref="stickyHeader"
      class="sticky-header"
      :class="{ 'sticky-active': isSticky }"
    >
      <div class="logo-container">
        <img 
          v-if="data && data.logo" 
          :src="data.logo" 
          alt="logo" 
          class="logo"
        >
      </div>
      <div v-if="data && data.children && data.children.length" class="nav-buttons">
        <el-button 
          v-for="(item, index) in data.children" 
          :key="index"
          @click="changeIndex(index)"
          :class="{ 'active': currentIndex === index }"
          type="text"
        >
          {{ item.title }}
        </el-button>
      </div>
    </div>
    
    <!-- 内容区域 -->
    <div class="content-container">
      <div 
        v-for="(item, index) in currentData" 
        :key="index"
        class="content-section"
      >
        <!-- 标题 -->
        <h2 v-if="item.show_title" class="section-title">
          {{ item.title }}
        </h2>
        
        <!-- 图片列表 -->
        <div v-if="item.img_text_layout==='top' || item.img_text_layout==='left' " class="image-grid">
          <div 
            v-for="(itemj, indexj) in item.imgdetailsList" 
            :key="indexj"
            :class="`grid-item col-${item.count_per_row || 1}`"
          >
            <div 
              class="image-content"
              :style="{ 
                flexDirection: item.img_text_layout === 'left' ? 'row' : 'column',
                alignItems:  'center'
              }"
            >
                          <!-- 文字内容 -->
              <div  class="text-wrapper">
                <div class="image-title">{{ itemj.title }}</div>
                <div class="image-description">{{ itemj.description }}</div>
              </div>
              <!-- 图片 -->
              <div 
              @click="handleImageClick(itemj.link)"
              v-if="item.type==='img'" class="image-wrapper" :style="{width:itemj.title && item.img_text_layout === 'left' ? '50%':'100%'}">
                <img 
                  :src="itemj.url" 
                  :alt="itemj.title"
                  class="content-image"
                >
              </div>
              

            </div>
          </div>
        </div>
        <div v-else class="image-grid">
          <div 
            v-for="(itemj, indexj) in item.imgdetailsList" 
            :key="indexj"
            :class="`grid-item col-${item.count_per_row || 1}`"
          >
            <div 
              class="image-content"
              :style="{ 
                flexDirection: item.img_text_layout === 'right' ? 'row' : 'column',
                alignItems: 'center'
              }"
            >
              <!-- 图片 -->
              <div
              @click="handleImageClick(itemj.link)"
              
              v-if="item.type==='img'" class="image-wrapper" :style="{width:itemj.title  && item.img_text_layout === 'right' ? '50%':'100%'}">
                <img 
                  :src="itemj.url" 
                  :alt="itemj.title"
                  class="content-image"
                >
              </div>
              
              <!-- 文字内容 -->
              <div  class="text-wrapper">
                <div class="image-title">{{ itemj.title }}</div>
                <div class="image-description">{{ itemj.description }}</div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- 文本内容 -->
        <div 
          v-if="item.text_content && item.type==='text'"
          class="text-content"
          :style="{ textAlign: item.text_layout || 'left' }"
          v-html="item.text_content"
        >
        </div>
      </div>
    </div>
    
    <!-- 页脚 -->
    <footer class="page-footer">
      <div v-if="data && data.footer" v-html="data.footer"></div>
    </footer>
  </div>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted, computed, onUnmounted } from 'vue'

// 获取当前组件实例
const instance = getCurrentInstance()
const data = ref(null)
const currentIndex = ref(0)
const stickyHeader = ref(null)
const isSticky = ref(false)

// 计算当前显示的数据
const currentData = computed(() => {
  if (data.value && data.value.children && data.value.children[currentIndex.value]) {
    try {
      return JSON.parse(data.value.children[currentIndex.value].content)
    } catch (error) {
      console.error('解析内容失败:', error)
      return []
    }
  }
  return []
})


const handleImageClick = (link) => {
  if (link) {
    window.open(link, '_blank')
  }
}

// const updateBlockHtml = (block) => {

//     return block
//       .replace(/\n/g, "<br>")
//       .replace(/\r/g, "");
  
// };

// 计算背景样式
const appStyle = computed(() => {
  if (data.value && data.value.children && data.value.children[currentIndex.value]?.bg) {
    return {
      backgroundImage: `url(${data.value.children[currentIndex.value].bg})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed', // 固定背景
      minHeight: '100vh'
    }
  }
  return {}
})

// 切换导航
const changeIndex = (index) => {
  currentIndex.value = index
  // 滚动到顶部
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

// 处理滚动吸顶
const handleScroll = () => {
  if (!stickyHeader.value) return
  
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  const headerHeight = stickyHeader.value.offsetHeight
  
  // 当滚动超过header高度时，添加吸顶效果
  isSticky.value = scrollTop > headerHeight
}

// 获取数据
const fetchData = async () => {
  try {
    let hostname = window.location.hostname;
    const response = await instance.proxy.$axios.get(`/ajax/web/domain/${hostname}`);
    // const response = await instance.proxy.$axios.get(`/ajax/web/domain/test.mengxuanwl.com`);
    if (response.code === 200) {
      data.value = response.data
      document.title = data.value.name || 'document'
      console.log('数据加载成功:', data.value)
    }
  } catch (error) {
    console.error('获取数据失败:', error)
  }
}

// 生命周期
onMounted(() => {
  fetchData()
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
/* 吸顶导航栏样式 */
.sticky-header {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  background: rgba(44, 62, 80, 0.3);
  padding:20px;
  box-sizing: border-box;
  transition: all 0.3s ease;
  position: sticky;
  top: 0;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.sticky-header.sticky-active {
  background: rgba(44, 62, 80, 0.9);
  padding: 15px 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

/* Logo 容器 */
.logo-container {
  width: 20%;
  min-width: 100px;
  max-width: 200px;
}

.logo {
  width: 100%;
  height: auto;
  display: block;
}

/* 导航按钮 */
.nav-buttons {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.nav-buttons .el-button {
  color: #e7e7e7;
  font-weight: normal;
  transition: all 0.3s ease;
  padding: 8px 16px;
}

.nav-buttons .el-button:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
}

.nav-buttons .el-button.active {
  color: #ffffff;
  font-weight: bold;
  background: rgba(255, 255, 255, 0.2);
}

/* 内容容器 */
.content-container {
  padding: 0 20px;
  max-width: 1200px;
  margin: 0 auto;
}

/* 内容区块 */
.content-section {
  margin-top: 30px;
  margin-bottom: 40px;
}

/* 区块标题 */
.section-title {
  font-weight: bold;
  text-align: left;
  margin-bottom: 20px;
  color: #333;
  font-size: 24px;
  padding-bottom: 10px;
  border-bottom: 2px solid #f0f0f0;
}

/* 图片网格 */
.image-grid {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px; /* 抵消子元素的外边距 */
}

.grid-item {
  padding: 10px;
  box-sizing: border-box;
}

/* 网格列宽 */
.col-1 { width: 100%; }
.col-2 { width: 50%; }
.col-3 { width: 33.333%; }
.col-4 { width: 25%; }
.col-5 { width: 20%; }
.col-6 { width: 16.666%; }

/* 图片内容区域 */
.image-content {
  display: flex;
  gap: 15px;
  padding: 15px;
  /* background: rgba(255, 255, 255, 0.9); */
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  height: 100%;
}

.image-content:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 图片包装器 */
.image-wrapper {
  flex-shrink: 0;
  width: 50%;
}

.content-image {
  width: 100%;
  /* max-width: 200px; */
  height: auto;
  border-radius: 4px;
  object-fit: cover;
}

/* 文字包装器 */
.text-wrapper {
  /* flex: 1; */
  width: 50%;
  min-width: 0; /* 防止文字溢出 */
}

.image-title {
  font-weight: bold;
  margin: 0 0 8px 0;
  color: #2c3e50;
  font-size: 20px;
}

.image-description {
  font-size: 16px;
  color: #666;
  line-height: 1.5;
  margin: 0;
}

/* 文本内容 */
.text-content {
  margin-top: 20px;
  padding-left: 2em;
  line-height: 1.8;
  color: #333;
  font-size: 14px;
  text-indent: 2em;
}

/* 页脚 */
.page-footer {
  /* position: absolute;
  bottom: 0;
  left: 0;
  right: 0; */
  text-align: center;
  padding: 20px;
  background: rgba(0, 0, 0, 0.2);
  border-top: 1px solid #eee;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .sticky-header {
    flex-direction: column;
    padding: 15px;
  }
  
  .logo-container {
    width: 40%;
    margin-bottom: 15px;
  }
  
  .nav-buttons {
    width: 100%;
    justify-content: center;
  }
  
  .content-container {
    padding: 0 15px;
  }
  
  .col-2,
  .col-3,
  .col-4,
  .col-5,
  .col-6 {
    width: 100%;
  }
  
  .image-content {
    flex-direction: column;
    text-align: center;
  }
  
  .content-image {
    max-width: 100%;
  }
  
  .text-content {
    padding-left: 1em;
  }
}

@media (max-width: 480px) {
  .nav-buttons {
    flex-direction: column;
    gap: 5px;
  }
  
  .nav-buttons .el-button {
    width: 100%;
    text-align: center;
  }
}
</style>